/**
 * GfG UI Kit — the primitive layer.
 *
 * Built to Judd's canonical component gallery (the design source of truth) from
 * the component parity review. Tailwind-first, using the tokens already registered
 * in src/index.css @theme. See ./README.md and GfG-UI-Kit-Gallery.html for the
 * live visual reference.
 */

export { default as GfgAvatar } from "../GfgAvatar";
// ── Reused as-is (approved in the parity review) ─────────────────────────────
// Re-exported from their existing homes so the kit is the single import surface.
export { default as GfgModal } from "../GfgModal";
export type { GfgButtonProps, GfgButtonTone, GfgButtonVariant } from "./GfgButton";
// ── Built to spec ──────────────────────────────────────────────────────────
export { GfgButton } from "./GfgButton";
export type { GfgSelectOption, GfgSelectProps } from "./GfgSelect";
export { GfgSelect } from "./GfgSelect";
export type { GfgTextFieldProps } from "./GfgTextField";
export { GfgTextField } from "./GfgTextField";
export type { TruncatedTextProps } from "./TruncatedText";
export { TruncatedText } from "./TruncatedText";
// Checkbox: use MUI's directly — `import { Checkbox } from "@mui/material";`
// (approved as-is; no wrapper needed).
